module.exports = __webpack_public_path__ + "img/emp-3.7f033bb3.jpeg";